<template lang="pug">
filter-detail-container(title="Filter Companies" :save-mode="false" @back="back" @clear="clear" @save="save")
  template(v-slot:body)
    .px-6.pt-6.pb-2.text-md Choose the company(s) that you want to filter:
    
    // Search input
    .px-6.pb-4
      v-text-field.round-xl(v-model="searchQuery" placeholder="Search company..." hide-details dense outlined clearable)
    
    .text-center.mt-8(v-if="isLoading")
      v-progress-circular(width="2" size="30" color="primary" indeterminate)
    div(v-else)
      // Select All option
      div(v-if="!searchQuery")
        .d-flex.text-sm.pa-6.cursor-pointer.hover-bg(@click="toggleSelectAll")
          yc-checkbox(v-model="selectAll" :indeterminate="isIndeterminate")
          .ml-4.font-medium All companies
        v-divider.basic300
      
      // Individual company options
      template(v-if="filteredCompanies.length")
        div(v-for="company in filteredCompanies" :key="company.id")
          .d-flex.text-sm.pa-6.cursor-pointer.hover-bg(@click="clickItem(company.id)")
            yc-checkbox(v-model="selected" :value="company.id")
            .ml-4
              .font-medium {{ company.name }}
          v-divider.basic300
      template(v-else)
        .px-6.py-4.text-sm.neutral500--text No company found
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import FilterDetailContainer from '@/components/connect/FilterDetailContainer.vue'

export default {
  props: {
    filter: {
      type: Object,
      default: () => {}
    }
  },
  components: { FilterDetailContainer },
  data: () => ({
    isLoading: true,
    selected: [],
    companies: [],
    searchQuery: ''
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    filteredCompanies() {
      if (!this.searchQuery || this.searchQuery.trim() === '') {
        return this.companies
      }
      const query = this.searchQuery.toLowerCase().trim()
      return this.companies.filter(company =>
        company.name.toLowerCase().includes(query)
      )
    },
    selectAll: {
      get() {
        return this.companies.length > 0 && this.selected.length === this.companies.length
      },
      set(value) {
        if (value) {
          this.selected = this.companies.map(company => company.id)
        } else {
          this.selected = []
        }
      }
    },
    isIndeterminate() {
      return this.selected.length > 0 && this.selected.length < this.companies.length
    }
  },
  created() {
    this.fetchCompanies()
    if (this.filter.items) {
      this.selected = this.filter.items
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchCompanies() {
      this.isLoading = true
      const params = {
        hq: this.company.id,
        fields: 'id,name',
        page_size: -1
      }
      this.$axios.get('/companies', { params })
        .then(resp => {
          if (!resp.data?.results) {
            this.companies = []
            this.isLoading = false
            return
          }
          
          this.companies = resp.data.results.map(item => {
            return {
              name: item.name,
              id: item.id
            }
          })
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    save() {
      const filter = {}
      if (this.selected.length) {
        filter['items'] = this.selected
      }
      this.$emit('update:filter', filter)
      this.back()
    },
    back() {
      this.$emit('onBack')
    },
    clear() {
      this.selected = []
    },
    clickItem(value) {
      if (this.selected.includes(value)) {
        this.selected = this.selected.filter(x => x !== value)
      } else {
        this.selected.push(value)
      }
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selected = []
      } else {
        this.selected = this.companies.map(company => company.id)
      }
    }
  }
}
</script>